import { createRouter, createWebHistory } from "vue-router";

import Participant from '@/Pages/Participant.vue'
import Consultant from '@/Pages/Consultant.vue'
import Login from '@/Pages/Auth/Login.vue'
import Play from "@/Pages/Participant/Play.vue";
import Vote from "@/Pages/Participant/Vote.vue";
import Feedback from "@/Pages/Participant/Feedback.vue";
import QuestionsEnd from "@/Pages/Participant/QuestionsEnd.vue";
import { useParticipantStore } from "@/Stores/ParticipantStore";
import NotAssigned from "./Pages/NotAssigned.vue";
import Upcoming from "./Pages/Upcoming.vue";
import Disconnected from "./Pages/Disconnected.vue";

// Out-of-session gating (no session / before it opens / after it closes) is handled
// server-side: the controllers render the Upcoming or NotAssigned page instead of the
// SPA, so this router only ever mounts while the session is active.
export const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/app',
            component: Participant,
            children: [
                {
                    path: '',
                    name: "Participant",
                    component: Play,
                    beforeEnter: (to, from, next) => {
                        // Read live state from the store, not the page-load snapshot in
                        // usePage().props (which never reflects votes/phase changes made
                        // during the SPA session and would bounce post-vote navigation).
                        const pStore = useParticipantStore()
                        pStore.initialize()
                        const s = pStore.state

                        console.log(to.name)
                        if (s.phase1.completed && !s.voteDone) {
                            console.log("Redirect to voting")
                            next({ name: "PartVote" })
                            return
                        }

                        if (s.phase2.completed && s.hasChat && !s.phase2.evaluated) {
                            console.log("Redirect to phase 2 consultant feedback")
                            next({ name: "PartFeedback" })
                            return
                        }

                        // The questionnaire (and its post-submit thank-you) is the final
                        // screen, so a participant who has finished phase 2 stays there
                        // whether or not they've submitted yet.
                        if (s.phase2.completed) {
                            console.log("Redirect to end questionnaire")
                            next({ name: "PartQEnd" })
                            return
                        }

                        next()
                    }
                },
                {
                    path: 'vote',
                    name: "PartVote",
                    component: Vote,
                    beforeEnter: (to, from, next) => {
                        const pStore = useParticipantStore()
                        pStore.initialize()

                        if (pStore.state.voteDone) {
                            console.log("Redirect to play")
                            next({ name: "Participant" })
                            return
                        }

                        next()
                    }
                },
                {
                    path: 'feedback',
                    name: "PartFeedback",
                    component: Feedback,
                    beforeEnter: (to, from, next) => {
                        const pStore = useParticipantStore()
                        pStore.initialize()
                        const s = pStore.state

                        // Only the consultant treatments rate phase 2, and only once.
                        // Everyone else (or an already-rated participant) skips ahead.
                        if (!s.phase2.completed) {
                            console.log("Redirect to play")
                            next({ name: "Participant" })
                            return
                        }

                        if (!s.hasChat || s.phase2.evaluated) {
                            console.log("Redirect to end questionnaire")
                            next({ name: "PartQEnd" })
                            return
                        }

                        next()
                    }
                },
                {
                    path: 'end',
                    name: "PartQEnd",
                    component: QuestionsEnd,
                    beforeEnter: (to, from, next) => {
                        const pStore = useParticipantStore()
                        pStore.initialize()

                        if (!pStore.state.phase2.completed) {
                            console.log("Redirect to play")
                            next({ name: "Participant" })
                            return
                        }

                        next()
                    }
                }
            ]
        },
        {
            path: '/consultant',
            component: Consultant,
            name: "Consultant",
        },
        {
            path: "/login",
            name: "Login",
            component: Login,
        },
        {
            name: 'NotAssigned',
            component: NotAssigned
        },
        {
            name: 'Upcoming',
            component: Upcoming
        },
        {
            name: 'Disconnected',
            component: Disconnected
        }
    ]
});
